import { IxEmailList } from './IxEmailList.js';

window.customElements.define('ix-email-list', IxEmailList);
